import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'
import DraftsTable from '../DraftsTable'

function ChooseDraftModelModal({
  modelId, modalIsOpen, closeModal, chooseModel,
}) {
  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={closeModal}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--choose-draft">
          <div className="l-inner-large">
            <div className="heading-20 u-mb10">Select from the draft list</div>
            <DraftsTable modelId={modelId} chooseModel={chooseModel} />
          </div>
        </div>
      </div>
    </Modal>
  )
}

ChooseDraftModelModal.propTypes = {
  modelId: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  chooseModel: PropTypes.func.isRequired,
}

export default ChooseDraftModelModal
